<template>
    <div :class="['cz__group', { 'cz__placements-expanded': expanded }]">
        <div class="cz__group-header">
            <button class="cz__button cz__collapse" @click="toggleGroup">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M6.101 359.293L25.9 379.092c4.686 4.686 12.284 4.686 16.971 0L224 198.393l181.13 180.698c4.686 4.686 12.284 4.686 16.971 0l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L232.485 132.908c-4.686-4.686-12.284-4.686-16.971 0L6.101 342.322c-4.687 4.687-4.687 12.285 0 16.971z"/></svg>
            </button>

            {{group.name}}
        </div>
        <div :class="['cz__placements']">
            <div v-for="placement in group.placements" v-if="!placement.placement.hidden" :key="placement.placement.code" class="cz__placement">
                <div class="cz__placement-header">
                    {{placement.placement.name}}
                </div>

                <div v-if="placement.definitions && placement.definitions.length > 0" class="cz__definitions">
                    <div v-for="definition in placement.definitions" :key="definition.description.code" class="cz__definition">
                        <div class="cz__definition-header">
                            {{definition.description.description || definition.description.definition}}
                        </div>

                        <div class="cz__options">
                            <template v-for="option in definition.options" v-if="option.option.custom && option.option.custom['widget-type']">
                                <option-widget
                                    :key="option.option.code"
                                    :controller="controller"
                                    :blueprint="blueprint"
                                    :option="option.option"
                                    :components="option.components"
                                    :selected="option.selected"
                                    @select="optionSelected(placement, $event)"
                                    @personalization="personalize(placement, $event)"
                                    @dynamicimage="setDynamicImage(placement, $event)"
                                ></option-widget>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less">
    .cz__group {
        & + .cz__group {
            position: relative;

            padding-top: 30px;

            &:before {
                content: '';

                position: absolute;

                left: 0;
                top: 15px;
                width: 300px;
                height: 1px;

                background: #cfcfcf;
            }
        }
    }

    .cz__placement {
        margin-bottom: 20px;
    }

    .cz__group-header {
        position: relative;
        color: #333;

        text-transform: uppercase;
    }

    .cz__collapse {
        position: absolute;

        width: 30px;
        height: 30px;

        right: 5px;
        top: -2px;

        border: none;
        background: transparent;
        color: #333;

        font-size: 20px;

        transition: transform 0.2s linear;

        transform: rotate(180deg);

        &:focus {
            outline: none;
        }

        span {
            position: absolute;

            left: 8px;
            top: -1px;
        }
    }

    .cz__placements {
        transition: max-height 0.2s linear;
        max-height: 0;
        overflow: hidden;
    }

    .cz__placements-expanded {
        .cz__placements {
            max-height: 2000px;
        }

        .cz__collapse {
            transform: rotate(0deg);
        }
    }

    .cz__placement-header {
        margin-top: 10px;

        font-size: 12px;

        color: #999;

        text-transform: uppercase;
    }

    .cz__definition {
        & + .cz__definition {
            margin-top: 20px;
        }
    }

    .cz__definition-header {
        margin: 15px 0 5px;

        font-size: 12px;

        color: #333;
    }
</style>

<script>
    import OptionWidget from './OptionWidget';

    export default {
        props: {
            controller: Object,
            group: Object,
        },
        data() {
            return {
                expanded: true,
            };
        },
        components: {
            OptionWidget,
        },
        computed: {
            blueprint() {
                return this.controller ? this.controller.blueprint : null;
            },
        },
        methods: {
            toggleGroup() {
                this.expanded = !this.expanded;
            },

            // Select a new option for placement.
            optionSelected(placement, option) {
                // Selected option is not a full component. In order to perform the actual selection,
                // we need to find the currently selected component for the placement, and attempt to
                // find a new component that matches all other options + the new one.

                // Find the currently select option by enumerating all components in the placement and checking which one is selected.
                const selectedOption = placement.placement.components.find(c => this.controller.isSelected(c.code));
                if (selectedOption && selectedOption.description) {
                    let searchOptions = [];

                    // Collect all options + replace one with the new selection.
                    selectedOption.description.forEach((description) => {
                        if (description.definition === option.definition) {
                            searchOptions.push(option);
                        } else {
                            searchOptions.push(description);
                        }
                    });

                    // Check if there are any components that match the new selection.
                    let matches = this.controller.searchComponents(placement.placement.code, searchOptions);

                    // If any found, apply the selection.
                    if (matches && matches.length > 0) {
                        this.controller.updateComponent(placement.placement.code, matches[0].code);
                    } else {
                        // If there are no matches, try to find any component that has the selected option, ignoring other selections.
                        searchOptions = [option];

                        matches = this.controller.searchComponents(placement.placement.code, searchOptions);

                        if (matches && matches.length > 0) {
                            this.controller.updateComponent(placement.placement.code, matches[0].code);
                        }
                    }
                }
            },

            // Personalize placement.
            personalize(placement, text) {
                this.controller.updatePersonalization(placement.placement.code, text);
            },

            // Set dynamic image.
            setDynamicImage(placement, options) {
                this.controller.updateDynamicImage(placement.placement.code, options);
            },
        },
    };
</script>